// extracted by css-extract-rspack-plugin
export default {"root":"I0C9ST"};